module.exports = __webpack_public_path__ + "static/media/DepotBase.ebdad4a5.zip";